export const mockProjects = {
  fishing: [
    { 
      id: 1, 
      name: "NB-0065 HARDHAUS", 
      year: 2021, 
      status: "completed",
      descKey: "hardhaus"
    },
    { 
      id: 2, 
      name: "NB-0070 LEILA", 
      year: 2021, 
      status: "completed",
      descKey: "leila"
    },
    { 
      id: 3, 
      name: "NB-0071 LAUREN", 
      year: 2022, 
      status: "completed",
      descKey: "lauren"
    },
    { 
      id: 4, 
      name: "NB-0073 VERONICA", 
      year: 2022, 
      status: "completed",
      descKey: "veronica"
    },
    { 
      id: 5, 
      name: "NB-0078 LIAFJORD", 
      year: 2023, 
      status: "completed",
      descKey: "liafjord"
    }
  ],
  ferry: [
    { 
      id: 6, 
      name: "NB-1091 HINNØY", 
      year: 2025, 
      status: "completed",
      descKey: "hinnoy"
    }
  ],
  offshore: [
    { 
      id: 7, 
      name: "NB-1094 – ESVAGT", 
      year: 2025, 
      status: "completed",
      type: "Wind Turbine Support Vessel",
      descKey: "esvagt1094"
    },
    { 
      id: 8, 
      name: "NB-1097 – ESVAGT", 
      year: null, 
      status: "ongoing",
      type: "Wind Turbine Support Vessel",
      descKey: "esvagt1097"
    }
  ]
};

export const mockServices = [
  {
    id: 1,
    key: "service1",
    icon: "Zap"
  },
  {
    id: 2,
    key: "service2",
    icon: "Workflow"
  },
  {
    id: 3,
    key: "service3",
    icon: "ShieldCheck"
  },
  {
    id: 4,
    key: "service4",
    icon: "Battery"
  },
  {
    id: 5,
    key: "service5",
    icon: "Cable"
  },
  {
    id: 6,
    key: "service6",
    icon: "Wrench"
  }
];
